var site = site || {};

site.direction = site.direction || {};

(function ($) {
  Drupal.behaviors.aboutBobbi = {
    attach: function (context) {
      var $timeline = $('.js-moments-slick', context);
      var $grid = $('.js-moments-grid', context);
      var $mobileMenu = $('.js-about-bobbi-nav', context);
      var $mobileContent = $('.js-slick-content', context);

      $timeline.slick({
        rtl: site.direction.isRTL,
        infinite: false
      });

      $mobileMenu.slick({
        rtl: site.direction.isRTL,
        centerMode: false,
        variableWidth: true,
        slidesToShow: 1,
        infinite: false,
        // // asNavFor: '.js-slick-content',
        // focusOnSelect: true,
        arrows: false
      });
      $('.js-mobile-page').eq(0).addClass('active');
      $('.js-about-bobbi-tabs', context).easyResponsiveTabs();
      $('.about-bobbi__moments-item', $grid).matchHeight();

      $('.js-mobile-link').on('click', function (e) {
        e.preventDefault();
        var index = $(this).index();

        $('.js-mobile-page').filter('.active').removeClass('active');
        $('.js-mobile-page').eq(index).addClass('active');
        $('.js-mobile-page').eq(index).find('.js-moments-slick').get(0).slick.setPosition();
      });
      // If we didn't load on the bobbi moments page, rerun the matchHeight
      $('.resp-tab-item', context).on('click', function () {
        $.fn.matchHeight._update();
      });
      // When an accordion is clicked, update the slick carousel in case it was hidden
      // This timeline only shows on mobile
      // Also set the position of the arrows for cosmetics
      $('.resp-accordion', context).on('click', function () {
        $timeline.get(0).slick.setPosition();
      });

      // About Bobbi Chapter Headers
      $('.about-bobbi__story-chapters__header', context).on('click', function (e) {
        e.preventDefault();
        // Close other open chapters
        var $otherOpenChapters = $('.about-bobbi__story-chapter.active', context);

        $otherOpenChapters = $otherOpenChapters.not($(this).parent());
        if ($otherOpenChapters) {
          $otherOpenChapters.removeClass('active').find('.about-bobbi__story-chapters__content').hide();
        }
        // Slide down this chapter
        var $target = $(this);

        $target.parent().toggleClass('active').find('.about-bobbi__story-chapters__content').stop().slideToggle();
        $('html, body').animate({
          scrollTop: $target.offset().top - 150
        }, 500);
      });
    }
  };
})(jQuery);
